import React from "react";
import { formatCurrency, formatDate } from "../../../helper/helper";
import StatusIndicator from "../../StatusIndicator/StatusIndicator";
import Table from "../../Table/CustomTable/Table";
import Pagination from "../../Pagination/Pagination";
import { TableWalletData, WalletTableDataType } from "./Types";

interface DesktopWalletTableProps {
  setSelectedTransaction: React.Dispatch<React.SetStateAction<WalletTableDataType | null>>;
  setShowTransactionModal: React.Dispatch<React.SetStateAction<boolean>>;
  handlePageChange: (page: number) => void;
  handleTableActionClick: (id: number) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  data: any[];
  selectedIconIndex: number | null;
  currentPageNumber: number;
  loading?: boolean;
  totalCount?: number;
  pageSize?: number;
  showViewAll?: boolean;
}

const DesktopWallet: React.FC<DesktopWalletTableProps> = (props) => {
  const {
    data,
    currentPageNumber,
    pageSize,
    totalCount,
    showViewAll,
    setSelectedTransaction,
    setShowTransactionModal,
    handlePageChange,
  } = props;

  const tableHead: {
    name: keyof TableWalletData;
    displayName: string;
  }[] = [
    { name: "amount", displayName: "Amount Funded" },
    { name: "invoiceNumber", displayName: "Invoice Number" },
    { name: "rrr", displayName: "RRR" },
    { name: "date", displayName: "Date" },
    { name: "status", displayName: "Status" },
  ];

  return (
    <>
      <div className="overflow-x-scroll ">
        <Table<TableWalletData, WalletTableDataType>
          fields={tableHead}
          tableData={data}
          // isLoading={isLoading}
          rows={10}
          handleRowClick={(item: any) => {
            setSelectedTransaction(item);
            setShowTransactionModal(true);
          }}
          builder={(field: any, data: any) => {
            switch (field.name) {
              case "amount":
                return <div>{formatCurrency(data?.amount)}</div>;
              case "date":
                return <div>{formatDate(data?.date)}</div>;
              case "status":
                return <div>{<StatusIndicator incomingStatus={data?.status} type="wallet" />}</div>;

              default:
                return data[field?.name];
            }
          }}
        />
      </div>

      {!showViewAll && (
        <Pagination
          totalItems={totalCount || 0}
          itemsPerPage={pageSize || 10}
          onPageChange={handlePageChange}
          currentPage={currentPageNumber}
        />
      )}
    </>
  );
};

export default DesktopWallet;
